<template>
  <el-dialog custom-class="min-dialog" title="修改密码" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false">
    <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
      <el-form-item label="原密码：" prop="oldPassword">
        <el-input type="password" v-model="ruleForm2.oldPassword" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newPassword">
        <el-input type="password" v-model="ruleForm2.newPassword" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="checkPass">
        <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm2')">提交</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {updatePasswordApi} from '../../api/login'

  export default {
    data() {
      var checkoldPassword = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('原密码不能为空'));
        }

        callback();
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } if (value.length<6) {
          callback(new Error('密码长度不能小于6位'));
        } else {
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm2.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        dialogFormVisible: false,
        ruleForm2: {
          newPassword: '',
          checkPass: '',
          oldPassword: ''
        },
        rules2: {
          newPassword: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          oldPassword: [
            { validator: checkoldPassword, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {   //调用登录接口
            updatePasswordApi({
              oldPassword: this.ruleForm2.oldPassword,
              newPassword: this.ruleForm2.newPassword,
            }).then(response => {
              if (response.data.code == 0) {//修改密码成功
                this.$message({
                  message: '密码修改成功！',
                  type: 'success'
                })
                this.ruleForm2.oldPassword='';
                this.ruleForm2.newPassword='';
                this.ruleForm2.checkPass='';
                this.dialogFormVisible=false;
              } else {
                this.$message.error({message: response.data.msg});
              }
            }).catch((error) => {
              console.log(error)
            });
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      show(){
        this.dialogFormVisible=true;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/ChangePass.vue